import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

const isBuildProject = (params) => params && params.theme === 'buildProject'

const PROJECT_BUILD_STATUS_OPTIONS = [
  { label: '筹备', value: '筹备' },
  { label: '在建', value: '在建' },
  { label: '竣工', value: '竣工' }
]

const PROJECT_BUILD_STATUS_TAGS = [
  { type: 'warning', label: '筹备', value: '筹备' },
  { type: 'success', label: '在建', value: '在建' },
  { type: 'info', label: '竣工', value: '竣工' }
]

const project = {
  project: {
    name: 'project',
    theme: '工程项目',
    componentTypes: ['navigate', 'check', 'tables', 'cardForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'project/getProjectList',
    deleteFun: 'project/deleteProject',
    getDetailFun: 'project/getProjectInfo',
    detailPage: [
      {
        buttonName: '新增',
        type: 'cardForm',
        name: 'project',
        theme: (params) => (isBuildProject(params) ? 'buildProject' : 'project'),
        step: 'projectInfo',
        label: (params) => (isBuildProject(params) ? '新增建设项目' : '新增工程项目')
      },
      {
        buttonName: '编辑',
        type: 'cardForm',
        name: 'project',
        theme: (params) => (isBuildProject(params) ? 'buildProject' : 'project'),
        step: 'projectInfo',
        label: (params) => (isBuildProject(params) ? '编辑建设项目' : '编辑工程项目'),
        checkType: 'checkByUid',
        checkFun: 'project/getProjectInfo'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    rowKey: 'orgUid',
    rowButtons: setTableButtons(['编辑', '删除']),
    subcomponents: ['project'],
    cardFormNames: ['project'],
    queryParams: {
      isKey: '',
      projectType: '',
      buildType: '',
      buildStatus: '',
      query: ''
    },
    selectData: [
      {
        key: 'isKey',
        label: '是否国家重点',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isFalse
        },
        checkByValue: true
      },
      {
        key: 'projectType',
        label: '工程分类',
        type: 'select',
        options: (params) => {
          return params.dictionarys.projectType
        }
      },
      {
        key: 'buildType',
        label: '建设性质',
        type: 'select',
        options: (params) => {
          return params.dictionarys.buildNature
        }
      },
      {
        key: 'buildStatus',
        label: '建设状态',
        type: 'select',
        options: PROJECT_BUILD_STATUS_OPTIONS
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: (params) => {
          return isBuildProject(params) ? '工程名称/工程所在地' : '工程名称/建设单位'
        }
      }
    ],
    hasPagination: true,
    rowData: (params) => {
      return params.state.project.projectList.result
    },
    rowTotal: (params) => {
      return params.state.project.projectList.totalSize
    },
    columns: (params) => {
      const cols = [
        { prop: 'projectName', label: '工程名称', width: '400px' },
        { prop: 'projectType', label: '工程分类', width: '' }
      ]
      if (!isBuildProject(params)) {
        cols.push({ prop: 'companyName', label: '建设单位', width: '360px' })
      }
      cols.push(
        { prop: 'buildType', label: '建设性质', width: '' },
        {
          prop: 'buildStatus',
          label: '建设状态',
          width: '',
          tag: PROJECT_BUILD_STATUS_TAGS
        },
        {
          prop: 'isKey',
          label: '是否国家重点项目',
          tag: (params) => {
            return params.dictionarys.isFalse
          }
        }
      )
      if (isBuildProject(params)) {
        cols.push({ prop: 'projectAddr', label: '工程所在地', minWidth: '300px' })
      }
      cols.push({ label: '操作', buttons: setTableButtons(['编辑', '删除']) })
      return cols
    },
    project: {
      bottomButtons: setFormButtons(['取消', '提交']),
      addFun: 'project/addProject',
      editFun: 'project/editProject',
      getDetailFun: 'project/getProjectInfo',
      formParams: {
        projectName: '',
        projectType: '',
        companyUid: (params) => {
          return isBuildProject(params) ? params.orgValue : ''
        },
        licenceNum: '',
        isKey: '',
        buildType: '',
        buildStatus: '',
        fundingSource: '',
        engPurpose: '',
        projectAddr: '',
        projectLnglat: '', // 经纬度
        projectCoordinate: {
          lng: '',
          lat: ''
        },
        projectArea: '',
        projectSize: '',
        projectInfo: ''
      },
      formRules: {
        projectName: [
          {
            required: true,
            message: '请输入工程名称',
            trigger: 'blur'
          }
        ],
        projectType: [
          {
            required: true,
            message: '请选择工程分类',
            trigger: 'blur'
          }
        ],
        isKey: [
          {
            required: true,
            message: '请选择是否国家重点',
            trigger: 'blur'
          }
        ],
        buildType: [
          {
            required: true,
            message: '请选择建设性质',
            trigger: 'blur'
          }
        ],
        buildStatus: [
          {
            required: true,
            message: '请选择建设状态',
            trigger: 'change'
          }
        ],
        projectAddr: [
          {
            required: true,
            message: '请选择项目所在地',
            trigger: 'blur'
          }
        ],
        projectLnglat: [
          {
            required: true,
            message: '未获取到项目坐标',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          card: '基础信息',
          fields: [
            {
              key: 'projectName',
              label: '工程名称',
              type: 'input',
              placeholder: '请输入工程名称全称'
            },
            {
              key: 'projectType',
              label: '工程分类',
              type: 'select',
              options: (params) => {
                return params.dictionarys.projectType
              }
            },
            {
              key: 'companyUid',
              label: '建设单位',
              type: 'select',
              placeholder: (params) => {
                return isBuildProject(params)
                  ? '自动关联当前企业'
                  : '选填，可在组织结构中关联'
              },
              filterable: true,
              clearable: (params) => !isBuildProject(params),
              remote: (params) => !isBuildProject(params),
              disabled: (params) => isBuildProject(params),
              options: (params) => {
                if (isBuildProject(params) && params.orgValue) {
                  return [
                    { label: params.orgName, value: params.orgValue }
                  ]
                }
                return params.state.enterprise.enterprises
              },
              checkByValue: true
            },
            {
              key: 'licenceNum',
              label: '施工许可证',
              type: 'input'
            },
            {
              key: 'isKey',
              label: '是否国家重点项目',
              type: 'select',
              options: (params) => {
                return params.dictionarys.isFalse
              },
              checkByValue: true
            },
            {
              key: 'buildType',
              label: '建设性质',
              type: 'select',
              options: (params) => {
                return params.dictionarys.buildNature
              }
            },
            {
              key: 'buildStatus',
              label: '建设状态',
              type: 'select',
              options: PROJECT_BUILD_STATUS_OPTIONS
            },
            {
              key: 'fundingSource',
              label: '资金来源',
              type: 'select',
              options: (params) => {
                return params.dictionarys.sourceFunds
              }
            },
            {
              key: 'engPurpose',
              label: '工程用途',
              type: 'select',
              options: (params) => {
                return params.dictionarys.engineeringUse
              }
            }
          ]
        },
        {
          card: '工程概况',
          fields: [
            {
              key: 'projectAddr',
              label: '工程所在地',
              type: 'input',
              placeholder: '请在地图中点选',
              inputButton: '地图点选',
              buttonIcon: 'el-icon-location-outline input_button_i',
              span: 24
            },
            {
              key: 'projectLnglat',
              label: '工程坐标',
              type: 'input',
              placeholder: '地图点选后自动获取',
              disabled: true
            },
            {
              key: 'projectArea',
              label: '建筑面积',
              type: 'input',
              inputButton: '㎡'
            },
            {
              key: 'projectSize',
              label: '里程长度',
              type: 'input',
              inputButton: 'km'
            },
            {
              key: 'projectInfo',
              label: '工程简介',
              type: 'input',
              placeholder: '请输入工程简介',
              inputType: 'textarea',
              autosize: { minRows: 6, maxRows: 8 },
              span: 24
            }
          ]
        }
      ]
    }
  }
}

export default project
